import { useMemo, useState } from 'react';
import Colors from 'library/constants/colors';
import Tag from 'library/components/tag';
import getThumbnailImageSource from 'library/helpers/get-thumbnail-image-source';
import {
  Icon,
  Img,
  InfoContainer,
  Label,
  Text,
  SetContainer,
  Container,
  ValueContainer,
  StyledLabel,
} from './styles';

const SetImage = (color) => (
  <svg fill={color} width="90" height="75" viewBox="0 0 90 75" xmlns="http://www.w3.org/2000/svg">
    <path fill={color} fillRule="evenodd" clipRule="evenodd" d="M10 5H36.8436C39.0896 5 41.06 6.49768 41.6612 8.66178L43.4218 15H5V10C5 7.23858 7.23858 5 10 5ZM0 15V10C0 4.47715 4.47715 0 10 0H36.8436C41.3357 0 45.2765 2.99536 46.4788 7.32356L48.6111 15H80C85.5229 15 90 19.4772 90 25V65C90 70.5229 85.5229 75 80 75H10C4.47715 75 0 70.5229 0 65V20V15ZM5 20V65C5 67.7614 7.23858 70 10 70H80C82.7614 70 85 67.7614 85 65V25C85 22.2386 82.7614 20 80 20H50H5Z" />
  </svg>
);

const Field = ({
  isSelected, onChange, title, src, isSetList, images = [], id, color,
}) => {
  const normalizedColor = color || Colors.violet;
  const setImage = useMemo(() => SetImage(normalizedColor.includes('#') ? normalizedColor : `#${normalizedColor}`), []);
  const [image] = images;

  return (
    <Label selected={isSelected} onClick={() => onChange(id)}>
      <InfoContainer>
        <Icon className="icon-check" selected={isSelected} />
        {
          isSetList ? (
            <SetContainer isSelected={isSelected}>
              {setImage}
            </SetContainer>
          ) : <Img src={src || getThumbnailImageSource(image)} title={title} />
        }

        <Text selected={isSelected}>
          {title}
        </Text>
      </InfoContainer>
    </Label>
  );
};

const Component = ({
  isSetList,
  options,
  inputRef,
  onChange,
  value,
  name,
  // allowedOptionMap,
}) => {
  const [localOptions, setLocalOptions] = useState(
    value ? [
      ...(
        Array.isArray(value) ? options.filter((i) => value.includes(i.value)) : [options?.find((i) => value === i?.value)]
      ),
    ] : [],
  );

  const handleChange = (id) => {
    if (Array.isArray(value)) {
      if (value.includes(id)) {
        const ids = value.filter((i) => i !== id);

        setLocalOptions(localOptions.filter((option) => option.value !== id));
        onChange(ids);
      } else {
        const ids = [...value, id];
        setLocalOptions([...(localOptions || []), options.find((data) => data.value === id)]);
        onChange(ids);
      }
    } else {
      setLocalOptions(id && id !== value ? [options.find((data) => id === data.value)] : []);
      onChange(value === id ? null : id);
    }
  };

  return (
    <>
      {localOptions.length ? (
        <Container>
          <StyledLabel>
            Selected value
            {localOptions.length > 1 ? 's' : ''}
            :&nbsp;&nbsp;&nbsp;
          </StyledLabel>
          <ValueContainer>
            {
              localOptions.map((option) => (
                <Tag key={option.value} isNew={option.value === 0}>
                  <strong>{option.text}</strong>
                  <span onClick={() => handleChange(option.value)}>&nbsp;&nbsp;&nbsp;x</span>
                </Tag>
              ))
            }
          </ValueContainer>
        </Container>
      ) : null}

      {
        options
          .map(({
            value: optionValue, text, src, images, color,
          }) => (
            <Field
              id={optionValue}
              key={optionValue}
              title={text}
              color={color}
              src={src}
              isSelected={
                Array.isArray(value) ? value.includes(optionValue) : value === optionValue
              }
              isSetList={isSetList}
              images={images}
              onChange={handleChange}
            />
          ))
      }
      <input type="hidden" ref={inputRef} name={name} />
    </>
  );
};

export default Component;
